var m = require('mithril');
var prop = require('mithril/stream');
var loaders = require('../../layout/components/loaders');
var Model = require('../../libs/Model');
var verticalListItem = require('../../components/verticalListItem');
var paginationWithSearch = require('../../data/components/paginationWithSearch');
var permissionGroupFilter = require('../../libs/permissionGroupFilter');

var permission = Object.create(Model)

permission.name = 'Permission';
permission['@class'] =  'Permission';
permission.url = 'permission';

permission.fields = {
  dashboard: {
    validators: {
      presence:true
    }
  },
  group: {
    validators: {
      presence: true
    }
  },
  read: {
    default: 0,
    validators: {}
  },
  write: {
    default: 0,
    validators: {}
  }
};

function isEnabled(value) {
  return Number(value) === 1;
}

function updateReadSelection(value) {
  permission.form.read(Number(value));
  if (!isEnabled(value)) {
    permission.form.write(0);
  }
}

function updateWriteSelection(value) {
  permission.form.write(Number(value));
  if (isEnabled(value)) {
    permission.form.read(1);
  }
}

permission.initForm = function (record) {
  loaders.requestWithLoader({
    url: '/api/v1/group/',
    method: 'GET'
  }).then( groups => {
    permission.vm.groups(permissionGroupFilter.availableGroupsForPermission(groups, permission.record));
  })

  permission.vm = {
    groups: prop(),
    selectedGroup: prop({}),
    newGroup: false
  }
  Model.initForm.call(permission, record);
  permission.form.groupsToShow = [];
  if(permission.form.group() && permission.form.group()['@rid']) {
    permission.form.group(permission.form.group()['@rid']); 
    permission.vm.newGroup = false;
  }
  else permission.vm.newGroup = true;
  if (isEnabled(permission.form.write())) {
    permission.form.read(1);
  }
};

permission.save = function () {
  if (isEnabled(permission.form.write())) {
    permission.form.read(1);
  }
  return Model.save.call(permission);
};

permission.view = function () {
  if (!permission.vm.groups()) return
  return m("form", {role: "form"}, [
    permission.errorView(),
    m("div.form-group",[
      m('label', 'Read'),
      m("select.form-control", {value: permission.form.read(), onchange: function(ev){updateReadSelection(ev.target.value)}}, [
        m("option", {value:0}, 'Disable'),
        m("option", {value:1}, 'Enable')
      ])
    ]),
    m("div.form-group",[
      m('label', 'Write'),
      m("select.form-control", {value: permission.form.write(), onchange: function(ev){updateWriteSelection(ev.target.value)}}, [
        m("option", {value:0}, 'Disable'),
        m("option", {value:1}, 'Enable')
      ])
    ]),
    permission.vm.newGroup ?
      m('div.mt2', [
        m(paginationWithSearch, {
          data: permission.vm.groups(),
          newNode: prop(false),
          dataToShow: permission.form.groupsToShow,
          placeHolder: 'Search group',
        },[
          permission.form.groupsToShow.map(function (group) {
            if(!group['@rid']) return;
            return m(verticalListItem, {onclick: permission.form.group.bind(this, group['@rid']), label: group.name}, [
              m('i', {class: 
                function getGroupIcon () {
                  var baseClass = 'fr ';
                  if (permission.form.group() === null) {return baseClass + 'ion-ios-circle-outline'};
                  if (permission.form.group() === group['@rid']) {
                    return baseClass + 'ion-ios-circle-filled'
                  }
                  else {
                    return baseClass + 'ion-ios-circle-outline' 
                  }
                }()
              })
            ])
          })
        ])
      ])
    :''
  ]);
};


module.exports = permission;
